const BRAND_TYPES = {
  DEFAULT: 'default',
  ALTERNATIVE: 'alt',
};

const isValidBrand = (type) => {
  const validValues = Object.values(BRAND_TYPES);

  return validValues.includes(type);
};

export default BRAND_TYPES;
export {isValidBrand};
